import { render } from "./remind.vue?vue&type=template&id=3bd69110&scoped=true&ts=true"
import script from "./remind.vue?vue&type=script&lang=ts"
export * from "./remind.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd69110"]])

export default __exports__